import { FunctionComponent } from "react";

import { PriorityDefinitionSection } from "./PriorityDefinitions/PriorityDefinitionSection";

import { SignalPriorityLevel, SignalPriorityItem } from "../schema/signal";

export interface PrioritySectionProps {
	priorityLevel: SignalPriorityLevel;
	items: SignalPriorityItem[];
	onAddItem: (priorityLevel: SignalPriorityLevel) => void;
	onEditItem: (item: SignalPriorityItem) => void;
	onDeleteItem: (item: SignalPriorityItem) => void;
	/** Enables dragging definitions in and out of this box (PREC-3908). */
	movable?: boolean;
}

export const PrioritySection: FunctionComponent<PrioritySectionProps> = ({
	priorityLevel,
	items,
	onAddItem,
	onEditItem,
	onDeleteItem,
	movable,
}) => {
	return (
		<PriorityDefinitionSection
			items={items}
			movable={movable}
			priorityLevel={priorityLevel}
			onAddItem={onAddItem}
			onDeleteItem={onDeleteItem}
			onEditItem={onEditItem}
		/>
	);
};
